<template>
  <div
    class="ja-kpi-card"
    :class="{ 'ja-kpi-card--highlight': highlight }"
  >
    <div class="ja-kpi-card__header">
      <div
        v-if="icon"
        class="ja-kpi-card__icon-wrap"
        :style="iconWrapStyle"
      >
        <feather-icon
          :icon="icon"
          svgClasses="ja-kpi-card__icon"
          :style="iconStyle"
        />
      </div>
      <span class="ja-kpi-card__title">{{ title }}</span>
    </div>
    <div class="ja-kpi-card__value">{{ value }}</div>
  </div>
</template>

<script>
export default {
  name: "KpiCard",
  props: {
    title: { type: String, required: true },
    value: { type: String, required: true },
    highlight: { type: Boolean, default: false },
    icon: { type: String, default: "" },
    iconColor: { type: String, default: "" },
  },
  computed: {
    resolvedColor() {
      return this.iconColor || "#6366F1";
    },
    iconWrapStyle() {
      if (this.highlight) {
        return { background: "rgba(255, 255, 255, 0.18)" };
      }

      return { background: this.hexToRgba(this.resolvedColor, 0.12) };
    },
    iconStyle() {
      return {
        color: this.highlight ? "#fff" : this.resolvedColor,
      };
    },
  },
  methods: {
    hexToRgba(hex, alpha) {
      const normalized = String(hex || "").replace("#", "");
      const value = normalized.length === 3
        ? normalized.split("").map((c) => c + c).join("")
        : normalized.slice(0, 6);
      const r = parseInt(value.slice(0, 2), 16) || 99;
      const g = parseInt(value.slice(2, 4), 16) || 102;
      const b = parseInt(value.slice(4, 6), 16) || 241;

      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
  },
};
</script>

<style scoped lang="scss">
.ja-kpi-card {
  background: #fff;
  border-radius: 18px;
  padding: 1.25rem 1.35rem;
  box-shadow: 0 1px 2px 0 rgba(20, 21, 34, 0.04);
  border: 1px solid #ececf2;
  min-height: 127.5px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  &--highlight {
    background: linear-gradient(128.53deg, #0f9d58 0%, #16a34a 100%);
    border-color: transparent;

    .ja-kpi-card__title,
    .ja-kpi-card__value {
      color: #fff;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    margin-bottom: 1.25rem;
  }

  &__icon-wrap {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    flex-shrink: 0;
  }

  &__icon {
    width: 18px;
    height: 18px;
  }

  &__title {
    font-size: 0.875rem;
    font-weight: 500;
    color: #6b7280;
    line-height: 1.25;
  }

  &__value {
    margin-top: auto;
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 30px;
    font-weight: 800;
    font-style: normal;
    line-height: 100%;
    letter-spacing: -0.6px;
    color: #16172b;
  }
}
</style>
